import React from 'react';
import { Outlet } from 'react-router-dom';
import { Permissions } from '@lanterds/types';
import { isAuthorized } from 'src/util/Permissions';
import { getUserEmailFromToken } from 'src/util/helpers';
import PermissionsError from 'src/components/common/PermissionsError/PermissionsError';

export default function UserManagementLayout() {
    const userEmail = getUserEmailFromToken();

    const isUserManagementAuthorized = isAuthorized(userEmail, Permissions.userManagement);
    return <>{isUserManagementAuthorized ? <Outlet /> : <PermissionsError />}</>;
}
